// File: AcademicPortfolio.jsx
// Place this file in your React project (e.g. src/components/AcademicPortfolio.jsx)
// Also create the CSS file shown below at: src/components/AcademicPortfolio.css

import React from "react";
import "./AcademicPortfolio.css";

const managementCourses = [
  "AI and ML Applications in Finance",
  "Statistics for Data Science",
  "Financial Technology – Basics",
  "Algorithmic trading",
  "Future, option and other derivatives",
  "Merger, Acquisition and Corporate Restructuring",
  "Management of Financial Institutions and Services",
  "International Finance",
  "Tax Planning and Management",
];

const otherRoles = [
  "Financial Accounting and Analysis",
  "Corporate Finance",
  "Financial Management",
  "Cost and Management Accounting",
  "Corporate Law",
  "Financial Risk and Insurance Management",
  "Security Analysis and Portfolio Management",
  "Management of Mutual Funds",
  "Managerial Economics",
];

const rolesRight = [
  "Academic coordinator",
  "MOOCs coordinator",
  "NSE Academy coordinator",
  "IIC member",
  "BOS member",
  "Paper Setter & Examiner",
];

export default function AcademicPortfolio() {
  return (
    <section className="ap-root" aria-labelledby="ap-heading">
      <div className="ap-container">
        <header className="ap-header" id="academics">
          <h1 id="ap-heading">Academic Portfolio</h1>
          <p className="ap-sub">Courses taught &amp; other academic roles</p>
        </header>

        <div className="ap-grid">
          <div className="ap-card ap-card--courses">
            <div className="ap-card-head">
              <h2>Management Courses Taught</h2>
              <span className="chip">{managementCourses.length}</span>
            </div>

            <ul className="ap-list">
              {managementCourses.map((c, i) => (
                <li key={i} className="ap-list-item">
                  <div className="bullet" />
                  <span>{c}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="ap-card ap-card--roles">
            <div className="ap-card-head">
              <h2>Other Subjects &amp; Roles</h2>
              <span className="chip">{otherRoles.length + rolesRight.length}</span>
            </div>

            <div className="ap-roles-grid">
              <div className="ap-roles-col">
                <h3 className="col-title">Other Subjects</h3>
                <ul className="ap-list small">
                  {otherRoles.map((r, i) => (
                    <li key={i} className="ap-list-item">
                      <div className="bullet small" />
                      <span>{r}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="ap-roles-col">
                <h3 className="col-title">Academic Roles</h3>
                <ul className="ap-list small">
                  {rolesRight.map((r, i) => (
                    <li key={i} className="ap-list-item">
                      <div className="bullet small" />
                      <span>{r}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
